import { mapGetters } from "vuex";
import {
  calculateDuration,
  checkDateFormat,
  formatDate,
  formatDateOnly,
  formatDateOnlyMysql,
  formatDateTimeMysql,
  formatDateTimeSql,
  formatEndDateSql,
  formatStartDateSql,
  formatTimeAgo,
  formatTimeOnly,
  formatTimeOnlyMysql,
  formatDateTimeDuration,
  formatDateOnlyPrettyShort
} from "../helpers/date";
import { formatClient, formatEoc, formatMrn } from "../helpers/episodeOfCare";
import { formatUser } from "../helpers/user";
import { toCurrencyValue, isStandalone } from "../helpers/general";

export default {
  install: Vue => {
    Vue.mixin({
      methods: {
        calculateDuration(dateFrom, dateTo) {
          return calculateDuration(dateFrom, dateTo);
        },
        checkDateFormat(date, format) {
          return checkDateFormat(date, format);
        },
        formatDate(date) {
          return formatDate(date);
        },
        formatDateOnly(date, format) {
          return formatDateOnly(date, format);
        },
        formatDateOnlyMysql(date, format) {
          return formatDateOnlyMysql(date, format);
        },
        formatDateTimeMysql(date, format) {
          return formatDateTimeMysql(date, format);
        },
        formatDateTimeSql(date) {
          return formatDateTimeSql(date);
        },
        formatEndDateSql(date, format) {
          return formatEndDateSql(date, format);
        },
        formatStartDateSql(date, format) {
          return formatStartDateSql(date, format);
        },
        formatTimeAgo(date) {
          return formatTimeAgo(date, this.getCurrentAdjustedDateTime());
        },
        formatTimeOnly(date, format) {
          return formatTimeOnly(date, format);
        },
        formatTimeOnlyMysql(date, format) {
          return formatTimeOnlyMysql(date, format);
        },
        formatDateTimeDuration(startDate, endDate, allDay = false) {
          return formatDateTimeDuration(startDate, endDate, allDay);
        },
        formatDateOnlyPrettyShort(date) {
          return formatDateOnlyPrettyShort(date);
        },
        formatClient(firstName, middleName, preferredName, lastName, mrn) {
          return formatClient(
            firstName,
            middleName,
            preferredName,
            lastName,
            mrn
          );
        },
        formatEoc(firstName, middleName, preferredName, lastName, mrn, eocn) {
          return formatEoc(
            firstName,
            middleName,
            preferredName,
            lastName,
            mrn,
            eocn
          );
        },
        formatEocObj(episodeOfCare) {
          return formatEoc(
            episodeOfCare.patient.firstName,
            episodeOfCare.patient.middleName,
            episodeOfCare.patient.preferredName,
            episodeOfCare.patient.lastName,
            episodeOfCare.patient.mrn,
            episodeOfCare.eocn
          );
        },
        formatMrn(mrn, eocn) {
          return formatMrn(mrn, eocn);
        },
        formatUser(user) {
          return formatUser(user);
        },
        toCurrencyValue(value) {
          return toCurrencyValue(value);
        },
        isStandalone() {
          return isStandalone();
        }
      },
      computed: {
        ...mapGetters("layout", ["getCurrentAdjustedDateTime"])
      }
    });
  }
};
